import React, { forwardRef } from 'react';
import ChatMessage from './ChatMessage';

const ChatOutput = forwardRef(({ messages, isLoading }, ref) => {
  return (
    <div id="chat-output" ref={ref}>
      {messages.map((message, index) => (
        <ChatMessage key={index} message={message} />
      ))}
      {isLoading && <div>Loading...</div>}
    </div>
  );
});

export default ChatOutput;